// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "async/" + chunkId + "." + {"158": "c672367e","979": "a0ca2bce",}[chunkId] + ".js"
}